module.exports = __webpack_public_path__ + "static/media/dealiem_terms_of_use.520b24b1.pdf";